import { render, staticRenderFns } from "./DialogAddTags.vue?vue&type=template&id=3b021349&scoped=true&"
import script from "./DialogAddTags.vue?vue&type=script&lang=js&"
export * from "./DialogAddTags.vue?vue&type=script&lang=js&"
import style0 from "./DialogAddTags.vue?vue&type=style&index=0&id=3b021349&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b021349",
  null
  
)

export default component.exports